import { createTheme, ThemeOptions } from "@mui/material/styles";
import colors from "./colors";
import typography from "./typography";

const darkTheme: ThemeOptions = createTheme({
  palette: {
    primary: {
      main: colors.dark.primary.blue,
      light: colors.dark.primary.light,
      dark: colors.dark.primary.blue100,
      contrastText: colors.dark.black.full,
    },
    secondary: {
      main: colors.dark.primary.orange,
    },
    background: {
      default: colors.dark.primary.background,
      paper: colors.dark.lightSurface.cloud,
    },
    text: {
      primary: colors.dark.black.full,
      secondary: colors.dark.black.light80,
      disabled: colors.dark.black.light40,
    },
    error: {
      main: colors.dark.semantic.error,
    },
    warning: {
      main: colors.dark.semantic.warning,
    },
    success: {
      main: colors.dark.semantic.success,
    },
    info: {
      main: colors.dark.semantic.information,
    },
    divider: colors.dark.greys[300],
  },
  typography,
  spacing: (factor: number) => `${0.25 * factor}rem`, // 4px scale
  shape: {
    borderRadius: 4,
  },
  shadows: [
    "none",
    "0px 1px 3px rgba(0, 0, 0, 0.12)",
    "0px 1px 5px rgba(0, 0, 0, 0.2)",
    "0px 3px 5px rgba(0, 0, 0, 0.12)",
    "0px 5px 5px rgba(0, 0, 0, 0.15)",
    "0px 3px 5px rgba(0, 0, 0, 0.2)",
    "0px 5px 10px rgba(0, 0, 0, 0.15)",
    "0px 7px 10px rgba(0, 0, 0, 0.2)",
    "0px 10px 10px rgba(0, 0, 0, 0.2)",
    "0px 10px 15px rgba(0, 0, 0, 0.1)",
    "0px 10px 20px rgba(0, 0, 0, 0.15)",
    "0px 12px 20px rgba(0, 0, 0, 0.2)",
    "0px 14px 24px rgba(0, 0, 0, 0.2)",
    "0px 17px 26px rgba(0, 0, 0, 0.2)",
    "0px 20px 30px rgba(0, 0, 0, 0.15)",
    "0px 22px 32px rgba(0, 0, 0, 0.2)",
    "0px 25px 35px rgba(0, 0, 0, 0.2)",
    "0px 28px 38px rgba(0, 0, 0, 0.2)",
    "0px 30px 40px rgba(0, 0, 0, 0.2)",
    "0px 32px 42px rgba(0, 0, 0, 0.15)",
    "0px 35px 45px rgba(0, 0, 0, 0.15)",
    "0px 37px 48px rgba(0, 0, 0, 0.2)",
    "0px 40px 50px rgba(0, 0, 0, 0.2)",
    "0px 42px 52px rgba(0, 0, 0, 0.15)",
    "0px 45px 55px rgba(0, 0, 0, 0.1)",
  ], // Full array of shadows for dark theme
 
components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '10px',
        },
        notchedOutline: {
          borderRadius: '10px',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderRadius: '10px',
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          borderRadius: '10px',
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        inputRoot: {
          borderRadius: '10px !important',
        },
      },
    },
  }
});

export default darkTheme;
